// extracted by mini-css-extract-plugin
export default {"r_l":"c9637d0c74 e47621658e","t":"c6c216f674"};